import { addDictionaryExtraLine, TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useOrderTypeShippingDict = () => {
    const {t} = useTwinTranslation()
    const dictTypeShipping: TwinDictionary = addDictionaryExtraLine({
        0: { name: t('sendToCustomer', 'Enviar al cliente') },
        1: { name: t('pickUpInWorkingCenter', 'Recogida en nuestro centro de trabajo') }
    })

    return dictTypeShipping
}

export default useOrderTypeShippingDict